module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-kpito-02.c9a6396f.jpg";